import React, { useState } from 'react'
import ServiceSlider, { ServiceSliderProps } from './ServiceSlider'
import { Booking, BrowseExperiencesQuery, BrowseServicesQuery, GeneralService, ServiceCarouselSectionQuery } from 'gql/graphql'
import { useQueryClient } from 'react-query'
import ServiceRequestModalWithAuth from 'components/modals/ServiceRequestModalWithAuth'


export interface ServiceSliderSectionProps extends ServiceSliderProps {
  data?: BrowseServicesQuery | BrowseExperiencesQuery | ServiceCarouselSectionQuery
  fetching: boolean
  booking?: Booking
}

const ServiceSliderSection = ({
  data,
  fetching,
  booking,
  ...props
}: ServiceSliderSectionProps) => {
  const [showServiceModal, setShowServiceModal] = useState<boolean>(false)

  const queryClient = useQueryClient()

  const serviceClick = (formLink: GeneralService['form_link']) => {
    if (formLink) {
      queryClient.refetchQueries(['bookings'])
      setShowServiceModal(true)
    }
  }

  return (
    <>
      <ServiceSlider
        {...props}
        isFetching={fetching}
        items={data?.services?.data.map((service) => {
          const [subheading, pill] = service.description?.split('\n') ?? [undefined, undefined]

          const requiredItems = {
            heading: service.title,
            subheading: subheading,
            pillText: pill ? [pill] : undefined,
            image: {
              media: service.service_image?.url,
              alt_text: service.image_alt_text ?? service.title,
            },
          }

          return service.slug
            ? { ...requiredItems, href: `/services/${service.slug}` }
            : (service.form_link && booking
              ? { ...requiredItems, href: `/home/reservations/${booking?.id}/service-request/${service.form_link}` }
              : { ...requiredItems, onClick: () => { serviceClick(service.form_link) } }
            )
        }) ?? []}
      />

      <ServiceRequestModalWithAuth
        isOpen={!!showServiceModal}
        onClose={() => setShowServiceModal(false)}
        service={showServiceModal}
        booking={booking}
      />
    </>
  )
}

export default ServiceSliderSection
